import { createFileRoute } from '@tanstack/react-router';
import { ManualPage } from '@/features/manual/pages/manual-page';

export const Route = createFileRoute('/_app/manual')({ component: ManualPage });
